(function() {

  var searchParams = window.location.search;
  var splitUrl = searchParams?.split( '?guest_token=' )[ 1 ];
  var guest_token = splitUrl?.split( '&' )[ 0 ];

  var params = new URLSearchParams(searchParams);
  var lastName = params.get("last_name");
  var referenceNumber = params.get("reference_number");

  if( guest_token && guest_token.length > 0  ) {

    $( '#packingFrame' ).attr( 'href', window.theme.yes_video_middleware_url + '/packing_list_labels/' + guest_token );

  } else if(lastName && lastName.length > 0 && referenceNumber && referenceNumber.length > 0 ) {

    $( '#packingFrame' ).attr( 'href', window.theme.yes_video_middleware_url + '/packing_list_labels/' + referenceNumber + "?last_name=" + lastName );

  }

})();
